import React, { useState } from "react";
import { Box, Collapse, IconButton, Paper, useTheme } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import CustomTypography from "../../../../../../views/components/common/form/CustomTypography";
import { OpsTatAppliedFilters } from "../../../../../../models/Dashboard/OpsTat/OpsTatFilters";
import { trackOpsTatAction } from "../../../../../../analytics/opsTatTracking";

interface OpsTatHowToReadProps {
  items: string[];
  /** Section id for GA (stages / dispatch / inward). */
  section?: string;
  filters?: OpsTatAppliedFilters | null;
}

const OpsTatHowToRead: React.FC<OpsTatHowToReadProps> = ({
  items,
  section = "section",
  filters,
}) => {
  const theme = useTheme();
  const customColors = theme.palette.customColors;
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    try {
      setOpen((prev) => {
        const next = !prev;
        trackOpsTatAction("how_to_read_toggle", filters, {
          expanded: next,
          section,
          context: {
            how_to_read_expanded: next,
            section,
          },
        });
        return next;
      });
    } catch (error) {
      console.error(error);
    }
  };

  if (items.length === 0) {
    return null;
  }

  return (
    <Paper
      variant="outlined"
      sx={{
        borderRadius: 2,
        borderColor: "divider",
        overflow: "hidden",
        mb: 2,
      }}
    >
      <Box
        onClick={handleToggle}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
          py: 0.5,
          cursor: "pointer",
          "&:hover": { bgcolor: theme.palette.action.hover },
        }}
      >
        <CustomTypography variant="heading7" color={customColors.navyText}>
          How to read
        </CustomTypography>
        <IconButton
          size="small"
          onClick={(event) => {
            event.stopPropagation();
            handleToggle();
          }}
          aria-label={open ? "Collapse how to read" : "Expand how to read"}
        >
          {open ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Box>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box
          sx={{
            px: 2,
            pt: 1,
            pb: 2,
            display: "flex",
            flexDirection: "column",
            gap: 0.75,
          }}
        >
          {items.map((item) => (
            <CustomTypography
              key={item}
              variant="body3"
              color={customColors.blackText}
              sx={{ display: "block", lineHeight: 1.45 }}
            >
              {item}
            </CustomTypography>
          ))}
        </Box>
      </Collapse>
    </Paper>
  );
};

export default OpsTatHowToRead;
